"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8977,5457],{

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .333A6.667 6.667 0 1 0 13.668 7 6.674 6.674 0 0 0 7.001.333ZM7 13a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M9.765 5.097 6.237 8.626a.333.333 0 0 1-.472 0L4.237 7.097a.334.334 0 0 0-.472.472l1.528 1.528a1 1 0 0 0 1.415 0l3.529-3.528a.334.334 0 1 0-.472-.472Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCheckmarkCircle);

/***/ }),

/***/ 74371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ search_box_locations; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 3 modules
var listbox = __webpack_require__(19363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(35703);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./public/assets/icons/ArrowDownPri.svg
var ArrowDownPri = __webpack_require__(36094);
// EXTERNAL MODULE: ./public/assets/icons/CheckmarkCircle.svg
var CheckmarkCircle = __webpack_require__(15457);
;// CONCATENATED MODULE: ./components/atoms/combobox/Combobox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                text-body--primary relative flex w-full items-center justify-between gap-2 rounded-full bg-white px-8 py-3 text-left text-text-primary\n                ",
        "\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      h-4 w-4 transition-transform\n                      ",
        "\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        relative flex cursor-default select-none items-center justify-between gap-6 truncate py-2 pl-3 pr-9\n                        ",
        "\n                        ",
        "\n                      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






/**
 * Combobox
 */ var Combobox = function(param) {
    var values = param.values, placeholder = param.placeholder, onChange = param.onChange, _className = param.className, className = _className === void 0 ? "" : _className, defaultValue = param.defaultValue, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = (0,react.useState)(placeholder && !defaultValue ? {
        id: "placeholder",
        label: placeholder
    } : defaultValue !== null && defaultValue !== void 0 ? defaultValue : values[0]), selected = ref[0], setSelected = ref[1];
    var onChangeHandler = function(value) {
        setSelected(value);
        onChange && onChange(value);
    };
    //Este codigo esta para cuando buscamos una localizacion desde el hero,
    //pero luego desde el donde estamos solo cambios de provincia,
    //da un error porque como se ha eligido anteriormente una poblacion
    //deja la locazacion anterior como por defecto, entonces
    //compruebo si en la provincia exite, si es asi funciona normal,
    //sino dejo el valor por defecto del placeholder.
    // TODO: Revisar como se crea el default value con rodri.
    (0,react.useEffect)(function() {
        setSelected(placeholder && !defaultValue ? {
            id: "placeholder",
            label: placeholder
        } : defaultValue !== null && defaultValue !== void 0 ? defaultValue : values[0]);
    }, [
        values,
        placeholder,
        defaultValue
    ]);
    (0,react.useEffect)(function() {
        setSelected(placeholder && !defaultValue ? {
            id: "placeholder",
            label: placeholder
        } : defaultValue !== null && defaultValue !== void 0 ? defaultValue : values[0]);
    }, []);
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
        value: selected,
        onChange: onChangeHandler,
        by: "id",
        disabled: disabled,
        children: function(param) {
            var open = param.open, value = param.value;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mt-2 ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Button */.R.Button, {
                            className: function(param) {
                                var disabled = param.disabled;
                                return (0,es/* oneLine */.f9)(_templateObject(), disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block truncate",
                                        children: (ref1 = value === null || value === void 0 ? void 0 : value.label) !== null && ref1 !== void 0 ? ref1 : placeholder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pointer-events-none flex items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownPri["default"], {
                                            className: (0,es/* oneLine */.f9)(_templateObject1(), open ? "rotate-180" : ""),
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            show: open,
                            as: "div",
                            leave: "transition ease-in duration-100",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            unmount: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                className: "absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1",
                                children: values.map(function(value) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                        value: value,
                                        className: function(param) {
                                            var active = param.active, selected = param.selected;
                                            return (0,es/* oneLine */.f9)(_templateObject2(), active ? "bg-surface-10 text-white" : "text-text-primary", selected ? "font-bold" : "cursor-pointer font-normal");
                                        },
                                        children: function(param) {
                                            var selected = param.selected;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    value.label,
                                                    selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkCircle["default"], {
                                                        className: "h-4 w-4",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            });
                                        }
                                    }, value.id);
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
};
Combobox.displayName = "Combobox";

;// CONCATENATED MODULE: ./components/atoms/combobox/index.ts

/* harmony default export */ var combobox = (Combobox);

;// CONCATENATED MODULE: ./components/molecules/search-box-locations/SearchBoxLocations.tsx



var ref;
/**
 * SearchBoxLocations
 */ var SearchBoxLocations = function(param) {
    var provinces = param.provinces, cities = param.cities, onCitiesChange = param.onCitiesChange, onProvincesChange = param.onProvincesChange;
    var ref1, ref2, ref3, ref4, ref5;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox, (0,_object_spread/* default */.Z)({
                values: provinces.values,
                onChange: function(value) {
                    return onProvincesChange(provinces.values.find(function(province) {
                        return province.id === value.id;
                    }));
                }
            }, provinces.placeholder ? {
                placeholder: provinces.placeholder
            } : {
                defaultValue: provinces.defaultValue
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox, (0,_object_spread/* default */.Z)({
                //eslint-disable-next-line
                //@ts-ignore
                values: (ref = cities === null || cities === void 0 ? void 0 : (ref1 = cities.cities) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[1]) === null || ref2 === void 0 ? void 0 : ref2.cities) !== null && ref !== void 0 ? ref : [],
                onChange: function(value) {
                    return onCitiesChange(value);
                },
                disabled: (cities === null || cities === void 0 ? void 0 : (ref3 = cities.cities) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[1]) === null || ref4 === void 0 ? void 0 : ref4.cities) ? ((ref5 = cities === null || cities === void 0 ? void 0 : cities.cities[1]) === null || ref5 === void 0 ? void 0 : ref5.cities.length) === 0 : true
            }, cities.defaultValue ? {
                defaultValue: cities.defaultValue
            } : {
                placeholder: cities.placeholder
            }))
        ]
    });
};
SearchBoxLocations.displayName = "SearchBoxLocations";

;// CONCATENATED MODULE: ./components/molecules/search-box-locations/index.ts

/* harmony default export */ var search_box_locations = (SearchBoxLocations);


/***/ }),

/***/ 8977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hero; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(78962);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/caption/index.ts + 1 modules
var atoms_caption = __webpack_require__(38959);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/molecules/search-box-locations/index.ts + 3 modules
var search_box_locations = __webpack_require__(74371);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(47675);
;// CONCATENATED MODULE: ./components/organisms/hero/Hero.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            u-wrapper z-10 h-full\n            ",
        "\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              m-auto flex h-auto flex-col justify-between gap-6 bg-cover md:h-fit md:justify-start md:gap-9\n              ",
        "\n              ",
        "\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var ReactHlsPlayer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4027), __webpack_require__.e(2665)]).then(__webpack_require__.bind(__webpack_require__, 62665));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62665)
            ];
        }
    },
    ssr: false
});
var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var PopUpBookingLavanda = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(2667), __webpack_require__.e(9501), __webpack_require__.e(4438)]).then(__webpack_require__.bind(__webpack_require__, 80735));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80735)
            ];
        }
    },
    ssr: false
});
var SearchBox = function(param) {
    var searchBox = param.searchBox;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)({
        id: -1,
        href: "#",
        label: ""
    }), selectedProvince = ref5[0], setSelectedProvince = ref5[1];
    var ref6 = (0,react.useState)({
        id: -1,
        href: "#",
        label: ""
    }), selectedCity = ref6[0], setSelectedCity = ref6[1];
    var ref7;
    var ref8 = (0,react.useState)((0,_object_spread/* default */.Z)({
        cities: searchBox === null || searchBox === void 0 ? void 0 : (ref = searchBox.cities) === null || ref === void 0 ? void 0 : (ref1 = ref.citiesList) === null || ref1 === void 0 ? void 0 : ref1.find(function(city) {
            return city.includes((ref7 = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) !== null && ref7 !== void 0 ? ref7 : -1);
        })
    }, (searchBox === null || searchBox === void 0 ? void 0 : (ref2 = searchBox.cities) === null || ref2 === void 0 ? void 0 : ref2.defaultValue) ? {
        defaultValue: searchBox === null || searchBox === void 0 ? void 0 : (ref3 = searchBox.cities) === null || ref3 === void 0 ? void 0 : ref3.defaultValue
    } : {
        placeholder: searchBox === null || searchBox === void 0 ? void 0 : (ref4 = searchBox.cities) === null || ref4 === void 0 ? void 0 : ref4.placeholder
    })), abailablesCities = ref8[0], setAbailableCities = ref8[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var ref5;
        setAbailableCities((0,_object_spread/* default */.Z)({
            cities: searchBox === null || searchBox === void 0 ? void 0 : (ref = searchBox.cities) === null || ref === void 0 ? void 0 : (ref1 = ref.citiesList) === null || ref1 === void 0 ? void 0 : ref1.find(function(city) {
                return city.includes((ref5 = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) !== null && ref5 !== void 0 ? ref5 : -1);
            })
        }, (searchBox === null || searchBox === void 0 ? void 0 : (ref2 = searchBox.cities) === null || ref2 === void 0 ? void 0 : ref2.defaultValue) ? {
            defaultValue: searchBox === null || searchBox === void 0 ? void 0 : (ref3 = searchBox.cities) === null || ref3 === void 0 ? void 0 : ref3.defaultValue
        } : {
            placeholder: searchBox === null || searchBox === void 0 ? void 0 : (ref4 = searchBox.cities) === null || ref4 === void 0 ? void 0 : ref4.placeholder
        }));
    }, [
        selectedProvince
    ]);
    var onCitiesChanges = function(city) {
        setSelectedCity(city);
    };
    var onProvincesChanges = function(value) {
        var ref, ref1;
        setSelectedProvince(searchBox === null || searchBox === void 0 ? void 0 : (ref = searchBox.provinces) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1.find(function(province) {
            return province.id === value.id;
        }));
        setSelectedCity(undefined);
    };
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var ref5;
        setAbailableCities((0,_object_spread/* default */.Z)({
            cities: searchBox === null || searchBox === void 0 ? void 0 : (ref = searchBox.cities) === null || ref === void 0 ? void 0 : (ref1 = ref.citiesList) === null || ref1 === void 0 ? void 0 : ref1.find(function(city) {
                return city.includes((ref5 = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) !== null && ref5 !== void 0 ? ref5 : -1);
            })
        }, (searchBox === null || searchBox === void 0 ? void 0 : (ref2 = searchBox.cities) === null || ref2 === void 0 ? void 0 : ref2.defaultValue) ? {
            defaultValue: searchBox === null || searchBox === void 0 ? void 0 : (ref3 = searchBox.cities) === null || ref3 === void 0 ? void 0 : ref3.defaultValue
        } : {
            placeholder: searchBox === null || searchBox === void 0 ? void 0 : (ref4 = searchBox.cities) === null || ref4 === void 0 ? void 0 : ref4.placeholder
        }));
    }, [
        searchBox
    ]);
    var onSearchHandler = function() {
        var ref, ref1;
        (0,helpers/* gtmPush */.De)({
            event: "booking_search",
            provincia: (ref = selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.label) !== null && ref !== void 0 ? ref : "",
            edificio: (ref1 = selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.label) !== null && ref1 !== void 0 ? ref1 : "",
            tipo: "",
            fecha: ""
        });
        if (selectedCity) {
            router_default().push(selectedCity.href);
        } else if (selectedProvince) {
            router_default().push(selectedProvince.href);
        }
    };
    var t = (0,useTranslation/* default */.Z)("common").t;
    return searchBox ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-8 grid w-full grid-cols-1 gap-4 text-left md:mb-10 md:grid-cols-2 md:gap-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_box_locations/* default */.Z, {
                    //  eslint-disable-next-line
                    // @ts-ignore
                    cities: abailablesCities,
                    provinces: searchBox.provinces,
                    onCitiesChange: onCitiesChanges,
                    onProvincesChange: onProvincesChanges
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                    onClick: onSearchHandler,
                    variant: "secondary",
                    size: "large",
                    disabled: (selectedProvince === null || selectedProvince === void 0 ? void 0 : selectedProvince.id) === -1,
                    className: "w-full md:w-auto",
                    children: t("components.organisms.hero.searchButton")
                })
            })
        ]
    }) : null;
};
/**
 * Hero
 */ var Hero = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, title = param.title, button = param.button, link = param.link, backgroundImage = param.backgroundImage, type = param.type, subtitle = param.subtitle, _textAling = param.textAling, textAling = _textAling === void 0 ? "start" : _textAling, textColor = param.textColor, _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? "502px" : _minHeight, hasScrollButton = param.hasScrollButton, searchBox = param.searchBox, hasLavandaPopUp = param.hasLavandaPopUp, lavandaBooking = param.lavandaBooking, hasImage = param.hasImage, video = param.video, backgroundImageMobile = param.backgroundImageMobile;
    var handlerScroll = function() {
        var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        window.scrollTo({
            top: vh,
            behavior: "smooth"
        });
    };
    var ref = (0,react.useState)(false), showLavandaPopUp = ref[0], setShowLavandaPopUp = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasLavandaPopUp && (lavandaBooking === null || lavandaBooking === void 0 ? void 0 : lavandaBooking.apartmentsByBuilding) && (lavandaBooking === null || lavandaBooking === void 0 ? void 0 : lavandaBooking.buildings) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpBookingLavanda, (0,_object_spread/* default */.Z)({
                defaultBuilding: lavandaBooking.defaultBuilding,
                show: showLavandaPopUp,
                onClose: function() {
                    return setShowLavandaPopUp(false);
                }
            }, lavandaBooking)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: type === "solid" ? "bg-surface-01 text-primary-400" : hasImage ? "relative text-white" : "relative flex h-screen  items-center justify-center overflow-hidden",
                children: [
                    type !== "solid" && hasImage && backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    src: backgroundImage,
                                    objectFit: "cover",
                                    priority: true,
                                    alt: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block md:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "block md:hidden",
                                    layout: "fill",
                                    src: backgroundImageMobile !== null && backgroundImageMobile !== void 0 ? backgroundImageMobile : backgroundImage,
                                    objectFit: "cover",
                                    priority: true,
                                    alt: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    background: "linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%)"
                                },
                                className: "absolute inset-0"
                            })
                        ]
                    }),
                    type !== "solid" && !hasImage && video && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHlsPlayer, {
                                src: "https://bedev-media.s3.eu-west-3.amazonaws.com/wp-content/uploads/2024/03/27112335/becasa.m3u8",
                                autoPlay: true,
                                controls: false,
                                id: "videoHero",
                                width: "100%",
                                height: "auto",
                                playsInline: true,
                                className: "absolute hidden min-h-full w-auto min-w-full max-w-none md:block",
                                loop: true,
                                muted: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHlsPlayer, {
                                src: "https://bedev-media.s3.eu-west-3.amazonaws.com/wp-content/uploads/2024/03/27121353/becasa-mobile.m3u8",
                                autoPlay: true,
                                controls: false,
                                id: "videoHero",
                                width: "100%",
                                height: "auto",
                                playsInline: true,
                                className: "absolute min-h-full w-auto min-w-full max-w-none md:hidden",
                                loop: true,
                                muted: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    background: "linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%)"
                                },
                                className: "absolute inset-0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,es/* oneLine */.f9)(_templateObject(), textAling === "center" ? "grid place-items-center" : ""),
                        style: (0,_object_spread/* default */.Z)({}, minHeight && type !== "solid" ? {
                            minHeight: minHeight
                        } : {}),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,es/* oneLine */.f9)(_templateObject1(), type === "essential" ? "max-w-[630px] px-5 py-[72px]" : "px-5 pb-9 pt-[72px] md:pt-[104px]", VARIANT_MAPS[textColor], textAling === "start" ? "justify-start text-start" : textAling === "center" ? "items-start justify-start md:items-center md:justify-center md:text-center" : "justify-end text-end", className),
                                children: [
                                    caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_caption/* default */.Z, {
                                        align: textAling,
                                        variant: textColor,
                                        className: "w-max",
                                        children: caption
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-heading text-heading-mobile--h1 md:text-heading--h1",
                                        dangerouslySetInnerHTML: {
                                            __html: title
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-heading text-heading--h5 mt-4",
                                        children: subtitle
                                    }),
                                    type === "default" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center justify-center gap-6 md:flex-row md:justify-normal md:gap-7 ",
                                        children: [
                                            !hasLavandaPopUp ? (button === null || button === void 0 ? void 0 : button.src) && button.label && button.variant && !hasLavandaPopUp && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: button.src,
                                                passHref: true,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                    className: "font-bold",
                                                    size: "large",
                                                    as: "a",
                                                    variant: button.variant,
                                                    children: button.label
                                                })
                                            }) : (button === null || button === void 0 ? void 0 : button.label) && (button === null || button === void 0 ? void 0 : button.variant) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                className: "font-bold",
                                                size: "large",
                                                variant: button.variant,
                                                onClick: function() {
                                                    return setShowLavandaPopUp(!showLavandaPopUp);
                                                },
                                                children: button.label
                                            }),
                                            (link === null || link === void 0 ? void 0 : link.src) && link.label && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link === null || link === void 0 ? void 0 : link.src,
                                                passHref: true,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                    arrow: true,
                                                    variant: link.variant,
                                                    children: link === null || link === void 0 ? void 0 : link.label
                                                })
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox, {
                                        searchBox: searchBox
                                    })
                                ]
                            }),
                            hasScrollButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: handlerScroll,
                                className: "absolute bottom-24 right-0 hidden md:inline-flex",
                                "aria-label": "Scroll down",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    src: "ArrowsDownCircle",
                                    height: 33,
                                    width: 33
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Hero.displayName = "Hero";

;// CONCATENATED MODULE: ./components/organisms/hero/index.ts

/* harmony default export */ var hero = (Hero);


/***/ }),

/***/ 47675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ gtmPush; },
/* harmony export */   "JQ": function() { return /* binding */ sha256; }
/* harmony export */ });
/* unused harmony export debugGtm */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36045);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74772);


var debugGtm = function(debugMsg, data) {
    var isProd = "production" === "production";
    // eslint-disable-next-line no-console
    if (!isProd) console.log("".concat(debugMsg, ": "), data);
};
var gtmPush = function(data) {
    var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ref;
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push(data);
    debugGtm("GTM PUSH", data);
};
function sha256(message) {
    return _sha256.apply(this, arguments);
}
function _sha256() {
    _sha256 = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(message) {
        var msgUint8, hashBuffer, hashArray, hashHex;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", msgUint8)
                    ];
                case 1:
                    hashBuffer = _state.sent();
                    hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
                    hashHex = hashArray.map(function(b) {
                        return b.toString(16).padStart(2, "0");
                    }).join(""); // convert bytes to hex string
                    return [
                        2,
                        hashHex
                    ];
            }
        });
    });
    return _sha256.apply(this, arguments);
}


/***/ }),

/***/ 19363:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ Nt; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(70379);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(98213);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(18575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(2711);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-computed.js
function use_computed_i(e,o){let[u,t]=(0,react.useState)(e),r=(0,use_latest_value/* useLatestValue */.E)(e);return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>t(r.current),[r,t,...o]),u}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(97588);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(75813);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(59126);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
var disposables = __webpack_require__(55675);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/calculate-active-index.js
var calculate_active_index = __webpack_require__(45118);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(88638);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(70340);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(66167);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(48099);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(62710);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(93972);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/form.js
function form_e(i={},s=null,t=[]){for(let[r,n]of Object.entries(i))o(t,f(s,r),n);return t}function f(i,s){return i?i+"["+s+"]":s}function o(i,s,t){if(Array.isArray(t))for(let[r,n]of t.entries())o(i,f(s,r.toString()),n);else t instanceof Date?i.push([s,t.toISOString()]):typeof t=="boolean"?i.push([s,t?"1":"0"]):typeof t=="string"?i.push([s,t]):typeof t=="number"?i.push([s,`${t}`]):t==null?i.push([s,""]):form_e(t,s,i)}function p(i){var t,r;let s=(t=i==null?void 0:i.form)!=null?t:i.closest("form");if(s){for(let n of s.elements)if(n!==i&&(n.tagName==="INPUT"&&n.type==="submit"||n.tagName==="BUTTON"&&n.type==="submit"||n.nodeName==="INPUT"&&n.type==="image")){n.click();return}(r=s.requestSubmit)==null||r.call(s)}}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(90762);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(41984);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-controllable.js
function use_controllable_T(l,r,c){let[i,s]=(0,react.useState)(c),e=l!==void 0,t=(0,react.useRef)(e),u=(0,react.useRef)(!1),d=(0,react.useRef)(!1);return e&&!t.current&&!u.current?(u.current=!0,t.current=e,console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")):!e&&t.current&&!d.current&&(d.current=!0,t.current=e,console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")),[e?l:i,(0,use_event/* useEvent */.z)(n=>(e||s(n),r==null?void 0:r(n)))]}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-tracked-pointer.js
var use_tracked_pointer = __webpack_require__(84915);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-text-value.js + 1 modules
var use_text_value = __webpack_require__(93851);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js
var Be=(n=>(n[n.Open=0]="Open",n[n.Closed=1]="Closed",n))(Be||{}),He=(n=>(n[n.Single=0]="Single",n[n.Multi=1]="Multi",n))(He||{}),Ge=(n=>(n[n.Pointer=0]="Pointer",n[n.Other=1]="Other",n))(Ge||{}),Ne=(i=>(i[i.OpenListbox=0]="OpenListbox",i[i.CloseListbox=1]="CloseListbox",i[i.GoToOption=2]="GoToOption",i[i.Search=3]="Search",i[i.ClearSearch=4]="ClearSearch",i[i.RegisterOption=5]="RegisterOption",i[i.UnregisterOption=6]="UnregisterOption",i[i.RegisterLabel=7]="RegisterLabel",i))(Ne||{});function z(e,a=n=>n){let n=e.activeOptionIndex!==null?e.options[e.activeOptionIndex]:null,r=(0,focus_management/* sortByDomNode */.z2)(a(e.options.slice()),t=>t.dataRef.current.domRef.current),l=n?r.indexOf(n):null;return l===-1&&(l=null),{options:r,activeOptionIndex:l}}let je={[1](e){return e.dataRef.current.disabled||e.listboxState===1?e:{...e,activeOptionIndex:null,listboxState:1}},[0](e){if(e.dataRef.current.disabled||e.listboxState===0)return e;let a=e.activeOptionIndex,{isSelected:n}=e.dataRef.current,r=e.options.findIndex(l=>n(l.dataRef.current.value));return r!==-1&&(a=r),{...e,listboxState:0,activeOptionIndex:a}},[2](e,a){var l;if(e.dataRef.current.disabled||e.listboxState===1)return e;let n=z(e),r=(0,calculate_active_index/* calculateActiveIndex */.d)(a,{resolveItems:()=>n.options,resolveActiveIndex:()=>n.activeOptionIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return{...e,...n,searchQuery:"",activeOptionIndex:r,activationTrigger:(l=a.trigger)!=null?l:1}},[3]:(e,a)=>{if(e.dataRef.current.disabled||e.listboxState===1)return e;let r=e.searchQuery!==""?0:1,l=e.searchQuery+a.value.toLowerCase(),p=(e.activeOptionIndex!==null?e.options.slice(e.activeOptionIndex+r).concat(e.options.slice(0,e.activeOptionIndex+r)):e.options).find(i=>{var b;return!i.dataRef.current.disabled&&((b=i.dataRef.current.textValue)==null?void 0:b.startsWith(l))}),u=p?e.options.indexOf(p):-1;return u===-1||u===e.activeOptionIndex?{...e,searchQuery:l}:{...e,searchQuery:l,activeOptionIndex:u,activationTrigger:1}},[4](e){return e.dataRef.current.disabled||e.listboxState===1||e.searchQuery===""?e:{...e,searchQuery:""}},[5]:(e,a)=>{let n={id:a.id,dataRef:a.dataRef},r=z(e,l=>[...l,n]);return e.activeOptionIndex===null&&e.dataRef.current.isSelected(a.dataRef.current.value)&&(r.activeOptionIndex=r.options.indexOf(n)),{...e,...r}},[6]:(e,a)=>{let n=z(e,r=>{let l=r.findIndex(t=>t.id===a.id);return l!==-1&&r.splice(l,1),r});return{...e,...n,activationTrigger:1}},[7]:(e,a)=>({...e,labelId:a.id})},J=(0,react.createContext)(null);J.displayName="ListboxActionsContext";function _(e){let a=(0,react.useContext)(J);if(a===null){let n=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,_),n}return a}let q=(0,react.createContext)(null);q.displayName="ListboxDataContext";function U(e){let a=(0,react.useContext)(q);if(a===null){let n=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,U),n}return a}function Ve(e,a){return (0,match/* match */.E)(a.type,je,e,a)}let Ke=react.Fragment;function Qe(e,a){let{value:n,defaultValue:r,form:l,name:t,onChange:p,by:u=(s,c)=>s===c,disabled:i=!1,horizontal:b=!1,multiple:R=!1,...m}=e;const P=b?"horizontal":"vertical";let S=(0,use_sync_refs/* useSyncRefs */.T)(a),[L=R?[]:void 0,y]=use_controllable_T(n,p,r),[T,o]=(0,react.useReducer)(Ve,{dataRef:(0,react.createRef)(),listboxState:1,options:[],searchQuery:"",labelId:null,activeOptionIndex:null,activationTrigger:1}),x=(0,react.useRef)({static:!1,hold:!1}),E=(0,react.useRef)(null),B=(0,react.useRef)(null),W=(0,react.useRef)(null),C=(0,use_event/* useEvent */.z)(typeof u=="string"?(s,c)=>{let O=u;return(s==null?void 0:s[O])===(c==null?void 0:c[O])}:u),A=(0,react.useCallback)(s=>(0,match/* match */.E)(d.mode,{[1]:()=>L.some(c=>C(c,s)),[0]:()=>C(L,s)}),[L]),d=(0,react.useMemo)(()=>({...T,value:L,disabled:i,mode:R?1:0,orientation:P,compare:C,isSelected:A,optionsPropsRef:x,labelRef:E,buttonRef:B,optionsRef:W}),[L,i,R,T]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{T.dataRef.current=d},[d]),(0,use_outside_click/* useOutsideClick */.O)([d.buttonRef,d.optionsRef],(s,c)=>{var O;o({type:1}),(0,focus_management/* isFocusableElement */.sP)(c,focus_management/* FocusableMode.Loose */.tJ.Loose)||(s.preventDefault(),(O=d.buttonRef.current)==null||O.focus())},d.listboxState===0);let H=(0,react.useMemo)(()=>({open:d.listboxState===0,disabled:i,value:L}),[d,i,L]),ie=(0,use_event/* useEvent */.z)(s=>{let c=d.options.find(O=>O.id===s);c&&X(c.dataRef.current.value)}),re=(0,use_event/* useEvent */.z)(()=>{if(d.activeOptionIndex!==null){let{dataRef:s,id:c}=d.options[d.activeOptionIndex];X(s.current.value),o({type:2,focus:calculate_active_index/* Focus.Specific */.T.Specific,id:c})}}),ae=(0,use_event/* useEvent */.z)(()=>o({type:0})),le=(0,use_event/* useEvent */.z)(()=>o({type:1})),se=(0,use_event/* useEvent */.z)((s,c,O)=>s===calculate_active_index/* Focus.Specific */.T.Specific?o({type:2,focus:calculate_active_index/* Focus.Specific */.T.Specific,id:c,trigger:O}):o({type:2,focus:s,trigger:O})),pe=(0,use_event/* useEvent */.z)((s,c)=>(o({type:5,id:s,dataRef:c}),()=>o({type:6,id:s}))),ue=(0,use_event/* useEvent */.z)(s=>(o({type:7,id:s}),()=>o({type:7,id:null}))),X=(0,use_event/* useEvent */.z)(s=>(0,match/* match */.E)(d.mode,{[0](){return y==null?void 0:y(s)},[1](){let c=d.value.slice(),O=c.findIndex(F=>C(F,s));return O===-1?c.push(s):c.splice(O,1),y==null?void 0:y(c)}})),de=(0,use_event/* useEvent */.z)(s=>o({type:3,value:s})),ce=(0,use_event/* useEvent */.z)(()=>o({type:4})),fe=(0,react.useMemo)(()=>({onChange:X,registerOption:pe,registerLabel:ue,goToOption:se,closeListbox:le,openListbox:ae,selectActiveOption:re,selectOption:ie,search:de,clearSearch:ce}),[]),Te={ref:S},G=(0,react.useRef)(null),be=(0,use_disposables/* useDisposables */.G)();return (0,react.useEffect)(()=>{G.current&&r!==void 0&&be.addEventListener(G.current,"reset",()=>{y==null||y(r)})},[G,y]),react.createElement(J.Provider,{value:fe},react.createElement(q.Provider,{value:d},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(d.listboxState,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},t!=null&&L!=null&&form_e({[t]:L}).map(([s,c],O)=>react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,ref:O===0?F=>{var Y;G.current=(Y=F==null?void 0:F.closest("form"))!=null?Y:null}:void 0,...(0,render/* compact */.oA)({key:s,as:"input",type:"hidden",hidden:!0,readOnly:!0,form:l,name:s,value:c})})),(0,render/* render */.sY)({ourProps:Te,theirProps:m,slot:H,defaultTag:Ke,name:"Listbox"}))))}let We="button";function Xe(e,a){var y;let n=(0,use_id/* useId */.M)(),{id:r=`headlessui-listbox-button-${n}`,...l}=e,t=U("Listbox.Button"),p=_("Listbox.Button"),u=(0,use_sync_refs/* useSyncRefs */.T)(t.buttonRef,a),i=(0,use_disposables/* useDisposables */.G)(),b=(0,use_event/* useEvent */.z)(T=>{switch(T.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:case keyboard/* Keys.ArrowDown */.R.ArrowDown:T.preventDefault(),p.openListbox(),i.nextFrame(()=>{t.value||p.goToOption(calculate_active_index/* Focus.First */.T.First)});break;case keyboard/* Keys.ArrowUp */.R.ArrowUp:T.preventDefault(),p.openListbox(),i.nextFrame(()=>{t.value||p.goToOption(calculate_active_index/* Focus.Last */.T.Last)});break}}),R=(0,use_event/* useEvent */.z)(T=>{switch(T.key){case keyboard/* Keys.Space */.R.Space:T.preventDefault();break}}),m=(0,use_event/* useEvent */.z)(T=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(T.currentTarget))return T.preventDefault();t.listboxState===0?(p.closeListbox(),i.nextFrame(()=>{var o;return(o=t.buttonRef.current)==null?void 0:o.focus({preventScroll:!0})})):(T.preventDefault(),p.openListbox())}),P=use_computed_i(()=>{if(t.labelId)return[t.labelId,r].join(" ")},[t.labelId,r]),S=(0,react.useMemo)(()=>({open:t.listboxState===0,disabled:t.disabled,value:t.value}),[t]),L={ref:u,id:r,type:(0,use_resolve_button_type/* useResolveButtonType */.f)(e,t.buttonRef),"aria-haspopup":"listbox","aria-controls":(y=t.optionsRef.current)==null?void 0:y.id,"aria-expanded":t.listboxState===0,"aria-labelledby":P,disabled:t.disabled,onKeyDown:b,onKeyUp:R,onClick:m};return (0,render/* render */.sY)({ourProps:L,theirProps:l,slot:S,defaultTag:We,name:"Listbox.Button"})}let $e="label";function ze(e,a){let n=(0,use_id/* useId */.M)(),{id:r=`headlessui-listbox-label-${n}`,...l}=e,t=U("Listbox.Label"),p=_("Listbox.Label"),u=(0,use_sync_refs/* useSyncRefs */.T)(t.labelRef,a);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>p.registerLabel(r),[r]);let i=(0,use_event/* useEvent */.z)(()=>{var m;return(m=t.buttonRef.current)==null?void 0:m.focus({preventScroll:!0})}),b=(0,react.useMemo)(()=>({open:t.listboxState===0,disabled:t.disabled}),[t]);return (0,render/* render */.sY)({ourProps:{ref:u,id:r,onClick:i},theirProps:l,slot:b,defaultTag:$e,name:"Listbox.Label"})}let Je="ul",qe=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function Ye(e,a){var T;let n=(0,use_id/* useId */.M)(),{id:r=`headlessui-listbox-options-${n}`,...l}=e,t=U("Listbox.Options"),p=_("Listbox.Options"),u=(0,use_sync_refs/* useSyncRefs */.T)(t.optionsRef,a),i=(0,use_disposables/* useDisposables */.G)(),b=(0,use_disposables/* useDisposables */.G)(),R=(0,open_closed/* useOpenClosed */.oJ)(),m=(()=>R!==null?(R&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open:t.listboxState===0)();(0,react.useEffect)(()=>{var x;let o=t.optionsRef.current;o&&t.listboxState===0&&o!==((x=(0,owner/* getOwnerDocument */.r)(o))==null?void 0:x.activeElement)&&o.focus({preventScroll:!0})},[t.listboxState,t.optionsRef]);let P=(0,use_event/* useEvent */.z)(o=>{switch(b.dispose(),o.key){case keyboard/* Keys.Space */.R.Space:if(t.searchQuery!=="")return o.preventDefault(),o.stopPropagation(),p.search(o.key);case keyboard/* Keys.Enter */.R.Enter:if(o.preventDefault(),o.stopPropagation(),t.activeOptionIndex!==null){let{dataRef:x}=t.options[t.activeOptionIndex];p.onChange(x.current.value)}t.mode===0&&(p.closeListbox(),(0,disposables/* disposables */.k)().nextFrame(()=>{var x;return(x=t.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})}));break;case (0,match/* match */.E)(t.orientation,{vertical:keyboard/* Keys.ArrowDown */.R.ArrowDown,horizontal:keyboard/* Keys.ArrowRight */.R.ArrowRight}):return o.preventDefault(),o.stopPropagation(),p.goToOption(calculate_active_index/* Focus.Next */.T.Next);case (0,match/* match */.E)(t.orientation,{vertical:keyboard/* Keys.ArrowUp */.R.ArrowUp,horizontal:keyboard/* Keys.ArrowLeft */.R.ArrowLeft}):return o.preventDefault(),o.stopPropagation(),p.goToOption(calculate_active_index/* Focus.Previous */.T.Previous);case keyboard/* Keys.Home */.R.Home:case keyboard/* Keys.PageUp */.R.PageUp:return o.preventDefault(),o.stopPropagation(),p.goToOption(calculate_active_index/* Focus.First */.T.First);case keyboard/* Keys.End */.R.End:case keyboard/* Keys.PageDown */.R.PageDown:return o.preventDefault(),o.stopPropagation(),p.goToOption(calculate_active_index/* Focus.Last */.T.Last);case keyboard/* Keys.Escape */.R.Escape:return o.preventDefault(),o.stopPropagation(),p.closeListbox(),i.nextFrame(()=>{var x;return(x=t.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})});case keyboard/* Keys.Tab */.R.Tab:o.preventDefault(),o.stopPropagation();break;default:o.key.length===1&&(p.search(o.key),b.setTimeout(()=>p.clearSearch(),350));break}}),S=use_computed_i(()=>{var o,x,E;return(E=(o=t.labelRef.current)==null?void 0:o.id)!=null?E:(x=t.buttonRef.current)==null?void 0:x.id},[t.labelRef.current,t.buttonRef.current]),L=(0,react.useMemo)(()=>({open:t.listboxState===0}),[t]),y={"aria-activedescendant":t.activeOptionIndex===null||(T=t.options[t.activeOptionIndex])==null?void 0:T.id,"aria-multiselectable":t.mode===1?!0:void 0,"aria-labelledby":S,"aria-orientation":t.orientation,id:r,onKeyDown:P,role:"listbox",tabIndex:0,ref:u};return (0,render/* render */.sY)({ourProps:y,theirProps:l,slot:L,defaultTag:Je,features:qe,visible:m,name:"Listbox.Options"})}let Ze="li";function et(e,a){let n=(0,use_id/* useId */.M)(),{id:r=`headlessui-listbox-option-${n}`,disabled:l=!1,value:t,...p}=e,u=U("Listbox.Option"),i=_("Listbox.Option"),b=u.activeOptionIndex!==null?u.options[u.activeOptionIndex].id===r:!1,R=u.isSelected(t),m=(0,react.useRef)(null),P=(0,use_text_value/* useTextValue */.x)(m),S=(0,use_latest_value/* useLatestValue */.E)({disabled:l,value:t,domRef:m,get textValue(){return P()}}),L=(0,use_sync_refs/* useSyncRefs */.T)(a,m);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(u.listboxState!==0||!b||u.activationTrigger===0)return;let A=(0,disposables/* disposables */.k)();return A.requestAnimationFrame(()=>{var d,H;(H=(d=m.current)==null?void 0:d.scrollIntoView)==null||H.call(d,{block:"nearest"})}),A.dispose},[m,b,u.listboxState,u.activationTrigger,u.activeOptionIndex]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>i.registerOption(r,S),[S,r]);let y=(0,use_event/* useEvent */.z)(A=>{if(l)return A.preventDefault();i.onChange(t),u.mode===0&&(i.closeListbox(),(0,disposables/* disposables */.k)().nextFrame(()=>{var d;return(d=u.buttonRef.current)==null?void 0:d.focus({preventScroll:!0})}))}),T=(0,use_event/* useEvent */.z)(()=>{if(l)return i.goToOption(calculate_active_index/* Focus.Nothing */.T.Nothing);i.goToOption(calculate_active_index/* Focus.Specific */.T.Specific,r)}),o=(0,use_tracked_pointer/* useTrackedPointer */.g)(),x=(0,use_event/* useEvent */.z)(A=>o.update(A)),E=(0,use_event/* useEvent */.z)(A=>{o.wasMoved(A)&&(l||b||i.goToOption(calculate_active_index/* Focus.Specific */.T.Specific,r,0))}),B=(0,use_event/* useEvent */.z)(A=>{o.wasMoved(A)&&(l||b&&i.goToOption(calculate_active_index/* Focus.Nothing */.T.Nothing))}),W=(0,react.useMemo)(()=>({active:b,selected:R,disabled:l}),[b,R,l]);return (0,render/* render */.sY)({ourProps:{id:r,ref:L,role:"option",tabIndex:l===!0?void 0:-1,"aria-disabled":l===!0?!0:void 0,"aria-selected":R,disabled:void 0,onClick:y,onFocus:T,onPointerEnter:x,onMouseEnter:x,onPointerMove:E,onMouseMove:E,onPointerLeave:B,onMouseLeave:B},theirProps:p,slot:W,defaultTag:Ze,name:"Listbox.Option"})}let tt=(0,render/* forwardRefWithAs */.yV)(Qe),ot=(0,render/* forwardRefWithAs */.yV)(Xe),nt=(0,render/* forwardRefWithAs */.yV)(ze),it=(0,render/* forwardRefWithAs */.yV)(Ye),rt=(0,render/* forwardRefWithAs */.yV)(et),Nt=Object.assign(tt,{Button:ot,Label:nt,Options:it,Option:rt});


/***/ }),

/***/ 36045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);